export const ASSETS = `
  ... on Asset_Assets {
      alt
      height
      permalink
      width
      focus_css
      contain_image
      orientation
      last_modified
    }
`;

/** Shared fields for bard/replicator button sets */
export const ContentButtonFields = `
  id
  button_title
  url { url title }
  type
  open_in_new_window_tab
  button_style {
    label
    value
  }
  use_custom_colours
  custom_button_background_color
  custom_button_foreground_color
`;

export const ContentButton = ContentButtonFields;

/** Event popup CTA grid (no bard `type` field) */
export const EventPopupButtonFields = `
  id
  button_title
  url { url title }
  open_in_new_window_tab
  button_style {
    label
    value
  }
  use_custom_colours
  custom_button_background_color
  custom_button_foreground_color
`;

export const ContentListGrid = `
  id
  type
  grid_items {
    item
    id
  }
`;

export const ContentExpandedListGrid = `
  id
  type
  grid_items {
    item
    id
    url { url title }
    open_in_new_window_tab
  }
`;

export const ContentColumns = `
  id
  columns {
    content
    id
  }
  type
`;

export const Tile = `
  id
  button_label
  button_style {
    label
    value
  }
  use_custom_colours
  custom_button_background_color
  custom_button_foreground_color
  description
  info
  link { url title }
  show_info
  show_border
  border_color
  subtitle
  title
  type
  image {
    ${ASSETS}
  }
  background_tile_color
  foreground_tile_color
`;

export const ContentAccordion = `
  ... on Set_Components_Content_Accordion {
    id
    type
    items {
      ... on Set_Components_Content_Items_Item {
        id
        heading
        type
        content {
          ... on Set_Components_Content_Items_Content_Button {
            ${ContentButtonFields}
          }
          ... on BardText {
            text
            type
          }
        }
      }
    }
  }
`;

export const RightCompetitorContentAccordion = `
  ... on Set_RightCompetitorContent_Accordion {
    id
    type
    items {
      ... on Set_RightCompetitorContent_Items_Item {
        id
        heading
        type
        content {
          ... on Set_RightCompetitorContent_Items_Content_Button {
            ${ContentButtonFields}
          }
          ... on BardText {
            text
            type
          }
        }
      }
    }
  }
`;

export const RightJudgingContentAccordion = `
  ... on Set_RightJudgingContent_Accordion {
    id
    type
    items {
      ... on Set_RightJudgingContent_Items_Item {
        id
        heading
        type
        content {
          ... on Set_RightJudgingContent_Items_Content_Button {
            ${ContentButtonFields}
          }
          ... on BardText {
            text
            type
          }
        }
      }
    }
  }
`;

export const RightSponsorsContentAccordion = `
  ... on Set_RightSponsorsContent_Accordion {
    id
    type
    items {
      ... on Set_RightSponsorsContent_Items_Item {
        id
        heading
        type
        content {
          ... on Set_RightSponsorsContent_Items_Content_Button {
            ${ContentButtonFields}
          }
          ... on BardText {
            text
            type
          }
        }
      }
    }
  }
`;

export const SponsorsContentAccordion = `
  ... on Set_SponsorsContent_Accordion {
    id
    type
    items {
      ... on Set_SponsorsContent_Items_Item {
        id
        heading
        type
        content {
          ... on Set_SponsorsContent_Items_Content_Button {
            ${ContentButtonFields}
          }
          ... on BardText {
            text
            type
          }
        }
      }
    }
  }
`;

export const JudgingContentAccordion = `
  ... on Set_JudgingContent_Accordion {
    id
    type
    items {
      ... on Set_JudgingContent_Items_Item {
        id
        heading
        type
        content {
          ... on Set_JudgingContent_Items_Content_Button {
            ${ContentButtonFields}
          }
          ... on BardText {
            text
            type
          }
        }
      }
    }
  }
`;

export const Tabs_TabLeftContentAccordion = `
  ... on Set_Tabs_TabLeftContent_Accordion {
    id
    type
    items {
      ... on Set_Tabs_TabLeftContent_Items_Item {
        id
        heading
        type
        content {
          ... on Set_Tabs_TabLeftContent_Items_Content_Button {
            ${ContentButtonFields}
          }
          ... on BardText {
            text
            type
          }
        }
      }
    }
  }
`;

export const Tabs_TabRightContentAccordion = `
  ... on Set_Tabs_TabRightContent_Accordion {
    id
    type
    items {
      ... on Set_Tabs_TabRightContent_Items_Item {
        id
        heading
        type
        content {
          ... on Set_Tabs_TabRightContent_Items_Content_Button {
            ${ContentButtonFields}
          }
          ... on BardText {
            text
            type
          }
        }
      }
    }
  }
`;

export const Menu_DescriptionAccordion = `
  ... on Set_Menu_Description_Accordion {
    id
    type
    items {
      ... on Set_Menu_Description_Items_Item {
        id
        heading
        type
        content {
          ... on Set_Menu_Description_Items_Content_Button {
            ${ContentButtonFields}
          }
          ... on BardText {
            text
            type
          }
        }
      }
    }
  }
`;

export const ContentWrappedImage =`
  id
  content
  alignment {
    label
    value
  }
  type
  size {
    label
    value
  }
  margin {
    label
    value
  }
  link_image { url title }
  image {
    ... on Asset_Assets {
      id
      alt
      height
      permalink
      width
      contain_image
    }
  }
`;

/** Bard + sets on entry `content` fields (Sets_Content union — not page-builder Components). */
export const SetsContentAccordion = `
  ... on Set_Content_Accordion {
    id
    type
    items {
      ... on Set_Content_Items_Item {
        id
        heading
        type
        content {
          ... on Set_Content_Items_Content_Button {
            ${ContentButtonFields}
          }
          ... on BardText {
            text
            type
          }
        }
      }
    }
  }
`;

export const SetsContentSelection = `
  ... on BardText {
    text
    type
  }
  ... on Set_Content_Button {
    ${ContentButton}
  }
  ... on Set_Content_ListGrid {
    ${ContentListGrid}
  }
  ... on Set_Content_ExpandedListGrid {
    ${ContentExpandedListGrid}
  }
  ... on Set_Content_Columns {
    ${ContentColumns}
  }
  ... on Set_Content_Image {
    id
    type
    width {
      label
      value
    }
    image {
      ${ASSETS}
    }
    link_image { url title }
  }
  ... on Set_Content_WrappedImage {
    ${ContentWrappedImage}
  }
  ${SetsContentAccordion}
`;
